export const GENERIC_GUIDE_LINK = 'https://aka.ms/ICGuide';
export const MSX_GUIDE_LINK = 'https://aka.ms/ICGuide_MSXEarnings';
export const FED_RBI_GUIDE_LINK = 'https://aka.ms/Federal-Earnings-RBI';
export const MSX_UBI_GUIDE_LINK = 'https://aka.ms/MSXEarningsUBI';
export const FED_UBI_GUIDE_LINK = 'https://aka.ms/Federal-Earnings-UBI';
export const MANAGER_GUIDE_LINK = 'https://aka.ms/ICGuide_MSXEarnings_Managers';
export const FED_MANAGER_RBI_GUIDE_LINK = 'https://aka.ms/Federal-Earnings-RBI-Managers';
export const MANAGER_UBI_GUIDE_LINK = 'https://aka.ms/MSXEarningsUBIMgr';
export const CALCULATED_ATTAINMENT_LINK = 'https://aka.ms/Icguide_calculateattainment';
export const FED_CALCULATED_ATTAINMENT_LINK = 'https://aka.ms/MSFed_CalculateAttainment';
export const MONTHLY_VIEW_LINK = 'https://aka.ms/MSXEarningsMonthlyView';
export const CONTACT_SUPPORT_LINK = 'https://aka.ms/ICGuide';
export const FED_FAQ_LINK = 'https://aka.ms/FederalEarningsFAQ';
export const PRIVACY_NOTICE_LINK = 'https://www.microsoft.com/en-us/privacy/data-privacy-notice';
export const SERVICE_AGREEMENT_LINK = 'https://www.microsoft.com/en/servicesagreement/';
export const CORP_DATA_SOURCES_LINK = 'https://aka.ms/MSXDataSources';
export const FED_DATA_SOURCES_LINK = 'https://aka.ms/Federal-Earnings-Data-Sources';
export const CORP_SALES_CONTESTS_LINK =
  'https://microsoft.sharepoint.com/teams/IncentiveCompensationGuide/SitePages/Contests/WW-Incentive-Compensation---Sales-Contests.aspx';
export const FED_SALES_CONTESTS_LINK = 'https://aka.ms/MSFed_SalesContests';
export const RAIN_GUIDE_LINK = 'https://aka.ms/rain';
export const WWIC_GUIDE_LINK = 'https://aka.ms/wwicsupport';
export const TOTAL_REWARDS_LINK = 'https://aka.ms/totalrewards';
export const PRODUCT_AND_SERIVICES_HIERARCHIES_LINK = 'https://aka.ms/ProductsandServicesHierarchies';
export const FED_SUPPORT_EMAIL = 'mailto:svc-fedicsup@microsoftfederal.com';
export const MCAPS_GUIDE_LINK = 'https://aka.ms/MSXEMCAPSDash';
export const CSO_GUIDE_LINK = 'https://aka.ms/MSXECSODash';
export const MSA_GUIDE_LINK = 'https://aka.ms/MSXEMSADash';
export const TOP_ATTAINMENT_ELIGIBILITY_LINK = 'https://aka.ms/TopAttainmentEligibilityChart';
export const TOP_ATTAINMENT_AWARDS_PROGRAM_LINK = 'https://aka.ms/TopAttainmentAwardsProgramSite';
export const MSXI_LINK = 'https://aka.ms/MSXEPlaceholderTargetText';
export const MSX_EARNINGS_SALES_LEADERS_LINK = 'https://aka.ms/MSXEarningsSalesLeaders';
